<template>
    <div></div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import moment from 'moment-timezone'
    import constants from '../../constants'

    export default {
        name: 'TimezoneDeviceSync',

        props: {
            confTimezone: {
                type: String,
                required: true,
            },
            authenticatable: {
                type: Object, // User or Doctor
                required: true,
            },
            userType: {
                type: String,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                timezones: [],
            };
        },

        created: async function() {
            const guessedZone = moment.tz.guess()

            // タイムゾーン設定がONではない
            if (this.confTimezone != 1) return

            // デバイスのタイムゾーンに合わせる設定がONではない
            if (this.authenticatable.is_device_timezone != 1) return

            // デバイスのタイムゾーンが変更されていなければ何もしない
            if (this.authenticatable.timezone === guessedZone) return

            await this.fetchTimezones()

            // デバイスのタイムゾーンが moment-timezone のリストに存在するなら更新
            if (this.timezones.some((timezone) => timezone.key === guessedZone)) {
                let endpoint
                if (this.userType === 'user') {
                    endpoint = constants.user.me.endpoint.base
                } else if (this.userType === 'doctor') {
                    endpoint = constants.doctor.me.endpoint.base
                }

                await axios.put(`${endpoint}/timezone`, { timezone: guessedZone })
                    .then(() => {
                        bus.$emit('timezone-updated', guessedZone)
                    })
            }
        },

        methods: {
            fetchTimezones: async function () {
                return await axios.get(constants.user.profile.endpoint.timezone)
                    .then(({data}) => {
                        const momentTimezones = moment.tz.names()
                        this.timezones = data.data.filter((d) => momentTimezones.includes(d.key))
                    })
            },
        },
    }
</script>
